import Route from '@ember/routing/route';

import type { ProgramsProgramCohortModel } from '../../cohort.ts';

export type ProgramsProgramCohortContentDiscussionsModel =
  ProgramsProgramCohortModel;

export default class ProgramsProgramCohortContentDiscussionsRoute extends Route<ProgramsProgramCohortContentDiscussionsModel> {
  model() {
    return this.modelFor(
      'programs.program.cohort'
    ) as ProgramsProgramCohortModel;
  }
}
